// src/loadDynamicScript.ts
function loadDynamicScript(id, src) {
  return new Promise((resolve) => {
    const existingScript = document.getElementById(id);
    if (!existingScript) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.src = src;
      script.id = id;
      document.body.appendChild(script);
      script.onload = () => {
        resolve();
      };
    }
    if (existingScript)
      resolve();
  });
}
export {
  loadDynamicScript as default
};
//# sourceMappingURL=index.js.map
